import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createReducer } from 'react-use';
import { initialState, reducer, updateState } from './reducer';
import { createRtsVideoHistoryMiddleware } from './rts-video-history-middleware';
import { snackbarMiddleware } from './snackbar-middleware';
import { storageMiddleware } from './storage-middleware';
import { useSnackbarDispatch } from '../../components/Snackbar/SnackbarContext';
import { useVideoConfig } from '../../config/VideoAppContext';
import { showHistoryStorage } from '../../storage/show-history-storage';
import { videoHistoryStorage } from '../../storage/video-history-storage';
import { useRtsAxios } from '../../utils/rts-login-helper';
import { useLoginState, usePersonalizationSettings } from '../DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoHistoryContext = /*#__PURE__*/React.createContext(undefined);
const VideoHistoryDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const VideoHistoryProvider = ({
  children
}) => {
  const {
    i18n
  } = useTranslation();
  const {
    loginSupported
  } = useVideoConfig();
  const {
    isLoggedIn
  } = useLoginState();
  const snackbarDispatch = useSnackbarDispatch();
  const rtsAxios = useRtsAxios();
  const {
    isActive: isPersonalizationActive
  } = usePersonalizationSettings();
  const useCustomReducer = createReducer(loginSupported ? createRtsVideoHistoryMiddleware(rtsAxios) : storageMiddleware, snackbarMiddleware(snackbarDispatch, i18n));
  const history = videoHistoryStorage.get();
  const initState = {
    ...initialState,
    videoHistory: history
  };
  updateState(initState);
  const [state, dispatch] = useCustomReducer(reducer, initState);
  useEffect(() => {
    dispatch({
      type: 'set-history',
      history: videoHistoryStorage.get()
    });
    dispatch({
      type: 'set-show-history',
      history: showHistoryStorage.get()
    });
  }, [isPersonalizationActive, dispatch]);
  useEffect(() => {
    if (loginSupported && !isLoggedIn) {
      dispatch({
        type: 'set-history',
        history: []
      });
      dispatch({
        type: 'set-show-history',
        history: []
      });
    }
  }, [loginSupported, isLoggedIn, dispatch]);
  useEffect(() => {
    if (loginSupported) {
      dispatch({
        type: 'load-history'
      });
    }
  }, [dispatch, loginSupported]);
  return /*#__PURE__*/_jsx(VideoHistoryContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(VideoHistoryDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const useVideoHistory = () => {
  const context = React.useContext(VideoHistoryContext);
  if (context === undefined) {
    throw new Error('useVideoHistory must be used within a VideoHistoryProvider');
  }
  return context;
};
export const useVideoHistoryDispatch = () => {
  const context = React.useContext(VideoHistoryDispatchContext);
  if (context === undefined) {
    throw new Error('useVideoHistoryDispatch must be used within a VideoHistoryProvider');
  }
  return context;
};